<template>
    <section @resize="onResize" :style="`--screen-width: ${width}px`" :class="{ 'noPB': $route.path === '/'}" class="appHero">
        <!-- <app-logo class="appHero__logo"></app-logo> -->
        <div class="appHero__image"></div>
        <div class="appHero__content">
          <slot></slot>
        </div>
        <!-- <img class="appHero__trophee" src="/images/trophee.png" alt=""> -->
        <!-- <div class="appHero__gradient"></div> -->
    </section>
</template>

<script>
// import AppLogo from '../Elements/app-logo';

export default {
  components: {
    // AppLogo,
  },
  data() {
    return {
      width: window.innerWidth,
    };
  },
  methods: {
    onResize() {
      this.width = window.innerWidth;
    },
  },
};
</script>

<style lang="scss">
.appHero {
    position: relative;
    background: var(--color-gray);
    // min-height: 100vh;
        overflow: hidden;
    display: grid;
    padding: 0 15px;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 15px;

    @include media('>=m') {
      padding: 0 30px 50px 30px;
      grid-template-columns: repeat(8, 1fr);
      column-gap: 20px;

      &.noPB {
        padding-bottom: 0;
      }
    }

    &__image {
      // grid-column: 1 / span 5;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('/images/bg-small.png');
      width: 100%;
      padding-bottom: 129%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;

      @include media('>=m') {
        // height: 100%;
        left: 8.333%;
        width: 63.165%;
        padding-bottom: 47.128%;
        background-image: url('/images/bg-medium.jpg');
      }
    }

    &__content {
      grid-column: 1 / span 4;
      padding-top: 167px;
      padding-top: 48vh;
      position: relative;
      z-index: 1;

      @include media('>=m') {
        grid-column: 5 / span 3;
        padding-top: 167px;
        // padding-right: 90px;
      }
    }

    // &__gradient {
    //     position: absolute;
    //     background: linear-gradient(rgba(230,0,124,0), var(--color-pink) 80%);
    //     bottom: 0;
    //     left: 0;
    //     height: 10%;
    //     width: 100%;
    //     z-index: 3;
    // }

    // &__trophee {
    //     position: absolute;
    //     bottom: 0;
    //     left: 45%;
    //     height: 80%;
    //     z-index: 2;

    //     @include media('<m') {
    //         left:0;
    //         width: 100%;
    //         height: 76%;
    //         object-fit: contain;
    //     }

    //     @include media('<s') {
    //         height: 80%;
    //     }
    // }

    // &__logo {
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     width: 70%;
    //     z-index: 1;

    //     @include media('<m') {
    //         width: 120%;
    //     }
    // }
}
</style>
